/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnblockRouteImport } from './routes/unblock'
import { Route as RecoveryRouteImport } from './routes/recovery'
import { Route as KycRequiredRouteImport } from './routes/kyc-required'
import { Route as EnterRouteImport } from './routes/enter'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RecoveryIndexRouteImport } from './routes/recovery.index'
import { Route as RecoveryVerifyRouteImport } from './routes/recovery.verify'
import { Route as DashboardUserIndexRouteImport } from './routes/dashboard/user/index'
import { Route as DashboardAdminIndexRouteImport } from './routes/dashboard/admin/index'
import { Route as DashboardUserProjectsIdRouteImport } from './routes/dashboard/user/projects/$id'

const UnblockRoute = UnblockRouteImport.update({
  id: '/unblock',
  path: '/unblock',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoveryRoute = RecoveryRouteImport.update({
  id: '/recovery',
  path: '/recovery',
  getParentRoute: () => rootRouteImport,
} as any)
const KycRequiredRoute = KycRequiredRouteImport.update({
  id: '/kyc-required',
  path: '/kyc-required',
  getParentRoute: () => rootRouteImport,
} as any)
const EnterRoute = EnterRouteImport.update({
  id: '/enter',
  path: '/enter',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoveryIndexRoute = RecoveryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RecoveryRoute,
} as any)
const RecoveryVerifyRoute = RecoveryVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => RecoveryRoute,
} as any)
const DashboardUserIndexRoute = DashboardUserIndexRouteImport.update({
  id: '/dashboard/user/',
  path: '/dashboard/user/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardAdminIndexRoute = DashboardAdminIndexRouteImport.update({
  id: '/dashboard/admin/',
  path: '/dashboard/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardUserProjectsIdRoute = DashboardUserProjectsIdRouteImport.update({
  id: '/dashboard/user/projects/$id',
  path: '/dashboard/user/projects/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/enter': typeof EnterRoute
  '/kyc-required': typeof KycRequiredRoute
  '/recovery': typeof RecoveryRouteWithChildren
  '/unblock': typeof UnblockRoute
  '/recovery/verify': typeof RecoveryVerifyRoute
  '/recovery/': typeof RecoveryIndexRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/user/': typeof DashboardUserIndexRoute
  '/dashboard/user/projects/$id': typeof DashboardUserProjectsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/enter': typeof EnterRoute
  '/kyc-required': typeof KycRequiredRoute
  '/unblock': typeof UnblockRoute
  '/recovery/verify': typeof RecoveryVerifyRoute
  '/recovery': typeof RecoveryIndexRoute
  '/dashboard/admin': typeof DashboardAdminIndexRoute
  '/dashboard/user': typeof DashboardUserIndexRoute
  '/dashboard/user/projects/$id': typeof DashboardUserProjectsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/enter': typeof EnterRoute
  '/kyc-required': typeof KycRequiredRoute
  '/recovery': typeof RecoveryRouteWithChildren
  '/unblock': typeof UnblockRoute
  '/recovery/verify': typeof RecoveryVerifyRoute
  '/recovery/': typeof RecoveryIndexRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/user/': typeof DashboardUserIndexRoute
  '/dashboard/user/projects/$id': typeof DashboardUserProjectsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/enter'
    | '/kyc-required'
    | '/recovery'
    | '/unblock'
    | '/recovery/verify'
    | '/recovery/'
    | '/dashboard/admin/'
    | '/dashboard/user/'
    | '/dashboard/user/projects/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/enter'
    | '/kyc-required'
    | '/unblock'
    | '/recovery/verify'
    | '/recovery'
    | '/dashboard/admin'
    | '/dashboard/user'
    | '/dashboard/user/projects/$id'
  id:
    | '__root__'
    | '/'
    | '/enter'
    | '/kyc-required'
    | '/recovery'
    | '/unblock'
    | '/recovery/verify'
    | '/recovery/'
    | '/dashboard/admin/'
    | '/dashboard/user/'
    | '/dashboard/user/projects/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EnterRoute: typeof EnterRoute
  KycRequiredRoute: typeof KycRequiredRoute
  RecoveryRoute: typeof RecoveryRouteWithChildren
  UnblockRoute: typeof UnblockRoute
  DashboardAdminIndexRoute: typeof DashboardAdminIndexRoute
  DashboardUserIndexRoute: typeof DashboardUserIndexRoute
  DashboardUserProjectsIdRoute: typeof DashboardUserProjectsIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unblock': {
      id: '/unblock'
      path: '/unblock'
      fullPath: '/unblock'
      preLoaderRoute: typeof UnblockRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recovery': {
      id: '/recovery'
      path: '/recovery'
      fullPath: '/recovery'
      preLoaderRoute: typeof RecoveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kyc-required': {
      id: '/kyc-required'
      path: '/kyc-required'
      fullPath: '/kyc-required'
      preLoaderRoute: typeof KycRequiredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enter': {
      id: '/enter'
      path: '/enter'
      fullPath: '/enter'
      preLoaderRoute: typeof EnterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recovery/': {
      id: '/recovery/'
      path: '/'
      fullPath: '/recovery/'
      preLoaderRoute: typeof RecoveryIndexRouteImport
      parentRoute: typeof RecoveryRoute
    }
    '/recovery/verify': {
      id: '/recovery/verify'
      path: '/verify'
      fullPath: '/recovery/verify'
      preLoaderRoute: typeof RecoveryVerifyRouteImport
      parentRoute: typeof RecoveryRoute
    }
    '/dashboard/user/': {
      id: '/dashboard/user/'
      path: '/dashboard/user'
      fullPath: '/dashboard/user/'
      preLoaderRoute: typeof DashboardUserIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/admin/': {
      id: '/dashboard/admin/'
      path: '/dashboard/admin'
      fullPath: '/dashboard/admin/'
      preLoaderRoute: typeof DashboardAdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/user/projects/$id': {
      id: '/dashboard/user/projects/$id'
      path: '/dashboard/user/projects/$id'
      fullPath: '/dashboard/user/projects/$id'
      preLoaderRoute: typeof DashboardUserProjectsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface RecoveryRouteChildren {
  RecoveryVerifyRoute: typeof RecoveryVerifyRoute
  RecoveryIndexRoute: typeof RecoveryIndexRoute
}

const RecoveryRouteChildren: RecoveryRouteChildren = {
  RecoveryVerifyRoute: RecoveryVerifyRoute,
  RecoveryIndexRoute: RecoveryIndexRoute,
}

const RecoveryRouteWithChildren = RecoveryRoute._addFileChildren(
  RecoveryRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EnterRoute: EnterRoute,
  KycRequiredRoute: KycRequiredRoute,
  RecoveryRoute: RecoveryRouteWithChildren,
  UnblockRoute: UnblockRoute,
  DashboardAdminIndexRoute: DashboardAdminIndexRoute,
  DashboardUserIndexRoute: DashboardUserIndexRoute,
  DashboardUserProjectsIdRoute: DashboardUserProjectsIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
